import { createAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { 
    ASYNC_LOGIN, 
    START_LOGIN, 
    STOP_LOGIN, 
    Login,
    FILL_LOGIN, 
    ERROR_LOGIN,
    ASYNC_CHANGE_PASSWORD,
    ERROR_CHANGE_PASSWORD,
    FILL_CHANGE_PASSWORD,
    START_CHANGE_PASSWORD,
    STOP_CHANGE_PASSWORD,
    ChangePassword,
    LoginAuth,
    SET_USER,
    SET_CLAIMS
} from "./types";


export const asyncLogin = createAction<LoginAuth>(ASYNC_LOGIN);
export const startLogin = createAction(START_LOGIN);
export const stopLogin = createAction(STOP_LOGIN);
export const fillLogin = createAction<Login>(FILL_LOGIN);
export const errorLogin = createAction<AxiosError>(ERROR_LOGIN);

export const asyncChangePassword = createAction<ChangePassword>(ASYNC_CHANGE_PASSWORD);
export const startChangePassword = createAction(START_CHANGE_PASSWORD);
export const stopChangePassword = createAction(STOP_CHANGE_PASSWORD);
export const fillChangePassword = createAction(FILL_CHANGE_PASSWORD);
export const errorChangePassword = createAction<AxiosError>(ERROR_CHANGE_PASSWORD);

export const setUser = createAction<string>(SET_USER);
export const setClaimsAction = createAction<string[]>(SET_CLAIMS);

